import image_1 from '../../assets/programs/ug_anveshan/image_1.webp'
import image_2 from '../../assets/programs/ug_anveshan/image_3.webp'
import image_3 from '../../assets/programs/sci_tech_spins/image1.webp'
import image_4 from '../../assets/programs/sci_tech_spins/image2.webp'
import image_5 from '../../assets/programs/ug_anveshan/image_4.webp'
import image_6 from '../../assets/programs/ug_anveshan/image_5.webp'
import image_7 from '../../assets/programs/ug_anveshan/image_6.webp'

const ug_anveshan_data = {
    "title": "ANVESHAN: INNOVATION AND EXPLORATION ACROSS DISCIPLINES",
    "description": "An initiative under #experienceIITD, with the objective of spreading awareness about the various disciplines of study among students planning to pursue master's and PhD degrees. This will help students make informed choices regarding their careers. The day-long event offers students the opportunity to receive one-on-one counselling from esteemed faculty members of IIT Delhi and also get a chance to experience life at IIT Delhi beyond academics through various exhibits by the student clubs at IIT Delhi.For more details: https://youtu.be/Rmk3iHRtX-Y?si=LUXhvVuhvzzMFzwk ",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image_2,
                            "desc": ""
                        },
                        {
                            "src": image_5,
                            "desc": ""
                        },
                        {
                            "src": image_6,
                            "desc": ""
                        },
                        {
                            "src": image_7,
                            "desc": ""
                        },
                        {
                            "src": image_1,
                            "desc": ""
                        },
                        {
                            "src": image_3,
                            "desc": ""
                        },
                        {
                            "src": image_4,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default ug_anveshan_data;